var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMatrixLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-15.905 44.091 4.428) skewX(.081)",
    stroke: "#4FB7CF",
    strokeWidth: 1.579,
    strokeLinecap: "round",
    d: "M.79-.79h15.687"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(19.242 -34.696 5.882) skewX(-.095)",
    stroke: "#F46069",
    strokeWidth: 1.579,
    strokeLinecap: "round",
    d: "M.79-.79h15.685"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-15.905 24.49 .535) skewX(.081)",
    stroke: "#4FB7CF",
    strokeWidth: 1.579,
    strokeLinecap: "round",
    d: "M.79-.79h15.687"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(19.242 -18.255 4.055) skewX(-.095)",
    stroke: "#F46069",
    strokeWidth: 1.579,
    strokeLinecap: "round",
    d: "M.79-.79h15.685"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatrixLogo);
export default __webpack_public_path__ + "static/media/matrixLogo.dec1c96e12729ca97a5c3408300275c8.svg";
export { ForwardRef as ReactComponent };